import React, { useState, useEffect } from "react";
import FullCalendar from "@fullcalendar/react"; // must go before plugins
import dayGridPlugin from "@fullcalendar/daygrid"; // a plugin!
import interactionPlugin from '@fullcalendar/interaction'; // a plugin!
import { ko } from "date-fns/locale";
import { Box, Select, MenuItem, FormControl, InputLabel } from "@mui/material";
import CenterSelect from "./CenterSelect";
import { configState, loginState } from "../lib/State";
import get_login from "../lib/get_login";
import is_admin from "../lib/is_admin";
import axios from "axios";
import get_token from "../lib/get_token";
import get_cid from "../lib/get_cid";
import moment from "moment";
import add_comma from "../lib/add_comma";
import { styled } from '@mui/system';
import PosCouponDay from './PosCouponDay';


const FullCalendarContainer = styled(Box)`
    width: 1000px;    
    
    .fc .fc-daygrid-body-unbalanced .fc-daygrid-day-events {
      min-height: 80px;
    }

`;

function PosTable(props) {
  const { tcidParent, login } = props;
  const [tcid, setTcid] = useState("");
  const [loaded, setLoaded] = useState(true);
  const cid = get_cid();
  const token = get_token();
  const [sdate, setSdate] = useState("");
  const [edate, setEdate] = useState("");
  const [rows, setRows] = useState([]);
  const [calendar_type, setCalendarType] = useState("sale");
  const [openDay, setOpenDay] = useState(false); // 일매출
  const [openWeek, setOpenWeek] = useState(false); // 주간매출
  const [tdate, setTdate] = useState('');
  const [sum1, setSum1] = useState(0);

  useEffect(() => {
    setTcid(tcidParent);
  }, [tcidParent]);
   
  const load_data = async () => {
    let result = await axios.post(configState.api + "/chart/coupon_calendar", {
      token: token,
      cid: cid,
      tcid: tcid,
      sdate: sdate,
      edate: edate,
    });
    
    if(result.data.success === 1) {
      setRows(result.data.rows);
      setSum1( result.data.sum1);
    }    
    
    // let i = 0;
    // // 정산금액 그래프
    // if (calendar_type === "sale") {
    //   for (i = 0; i < result.data.rows.length; i++) {
    //     result.data.rows[i].title =
    //       result.data.rows[i].sum > 0 ? '수업:' + add_comma(result.data.rows[i].sum)
    //         : "";
    //   }
    // }

    // if (calendar_type === "total")
    //   for (i = 0; i < result.data.rows.length; i++) {
    //     if (moment(result.data.rows[i].date).day() === 2) {
    //       // 화요일
    //       if (i - 3 > 0) {
    //         result.data.rows[i].title =
    //           result.data.rows[i - 3].week_sum > 0
    //             ? add_comma(result.data.rows[i - 3].week_sum)
    //             : ""; // 3일전 합계를 타이틀로
    //       }
    //     }
    //   }

    // 0 제거
    // setRows(result.data.rows.filter((el) => el.title !== ""));

    // setRows([
    //   {
    //     id: 1,
    //     date: '2022-07-05',
    //     title: '내용1'
    //   },
    //   {
    //     id: 2,
    //     date: '2022-07-05',
    //     title: '내용2'
    //   },
    // ])

  };

  useEffect(() => {
    console.log("login:", login.mcd);
    console.log("tcid:", tcid);
    console.log("sdate:", sdate);
    console.log("edate:", edate);

    if (login.mcd !== "" && tcid !== "" && sdate !== "" && edate !== "") {
      load_data();
    }
  }, [login, tcid, sdate, edate, calendar_type]);

  const monthChange = (playload) => {
    setSdate(moment(playload.start).format("YYYY-MM-DD"));
    setEdate(moment(playload.end).format("YYYY-MM-DD"));
  };


  // 날짜선택 후 팝업
  const onSelect = (info) => {
    setTdate(info.startStr);
    setOpenDay(true);
  }


  return (
    <Box paddingTop={1}>

      {/* 쿠폰 1일 매출 */}
      <PosCouponDay open={openDay} setOpen={setOpenDay}
        login={login} reload={load_data}
        tcid={tcid}
        tdate={tdate}
      ></PosCouponDay>

      <Box display="flex" maxWidth={1000}>
        <Box flexGrow={1}>쿠폰금액 합계 : {add_comma(sum1)}</Box>
        <Box>
          <CenterSelect login={login} tcidParent={tcid} setTcidParent={setTcid} />
        </Box>
      </Box>

      {/* <Box sx={{ mt: 3 }}>
        <FormControl>
          <InputLabel id="demo-select-1">달력보기</InputLabel>
          <Select
            name="calendar_type"
            labelId="demo-select-1"
            id="demo-select-1"
            label="달력보기"
            size="small"
            value={calendar_type}
            onChange={(e) => {
              setCalendarType(e.target.value);
            }}
            sx={{ width: 160 }}
          >
            <MenuItem value="sale">일간매출</MenuItem>
            <MenuItem value="total">주간매출</MenuItem>
          </Select>
        </FormControl>
      </Box> */}

      <Box marginTop={3}></Box>

      <FullCalendarContainer>
        <FullCalendar
          selectable={true}
          plugins={[dayGridPlugin, interactionPlugin]}
          initialView="dayGridMonth"
          events={rows}
          locale="ko"
          datesSet={monthChange}
          showNonCurrentDates={true}
          select={onSelect}
          eventOrder={false}
          fixedWeekCount={false}
        />
      </FullCalendarContainer>      
      
    </Box>
  );
}

export default PosTable;
